import { postRequest } from '@/utils/api';
<template>
    <div style="width: 420px;margin: 0 auto">
        <div style="margin: 20px;"></div>
        <el-form :label-position="labelPosition" label-width="100px" :model="formLabel" :rules="rules" ref="formLabel">
            <el-form-item label="客户名称:" prop="name">
                <el-input v-model="formLabel.name" placeholder="请输入代理商姓名"></el-input>
            </el-form-item>
            <el-form-item label="联系电话:" prop="mobile">
                <el-input v-model="formLabel.mobile" placeholder="请输入联系电话"></el-input>
            </el-form-item>
            <el-form-item label="工作职位:" prop="job">
                <el-input v-model="formLabel.job" placeholder="请输入工作职位"></el-input>
            </el-form-item>
            <el-form-item label="qq号码:" prop="qq">
                <el-input v-model="formLabel.qq" placeholder="请输入qq号码"></el-input>
            </el-form-item>
            <el-form-item label="email:" prop="email">
                <el-input v-model="formLabel.email" placeholder="请输入用户邮箱"></el-input>
            </el-form-item>
            <el-form-item label="所在地:" prop="city">
                <el-select placeholder="省" v-model="province" @change="changeProvince" style="width:102px" prop="province">
                    <el-option v-for="(item, index) in data" :key="index" :label="item.label" :value="index + item.value"> </el-option>
                </el-select>
                <el-select v-model="city" @change="changeCity" placeholder="市" style="width:102px" prop="city">
                    <el-option v-for="(item, index2) in data_city" :key="index2" :label="item.label" :value="index2 + item.value"> </el-option>
                </el-select>
                <el-select v-model="area" placeholder="县/区" style="width:102px" @change="changeArea" prop="area">
                    <el-option v-for="(item, index3) in data_area" :key="index3" :label="item.label" :value="index3 + item.value"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="详细地址:" prop="address">
                <el-input type="textarea" v-model="formLabel.address" placeholder="请输入详细地址"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm">提交信息</el-button>
                <el-button @click="resetForm('formLabel')">重置</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import { postRequest } from '@/utils/api';
import { regionData } from 'element-china-area-data';
export default {
    name: 'AddAgent',
    data() {
        return {
            id: '',
            labelPosition: 'right',
            province: '', //省
            city: '', //市
            area: '', //县
            data: regionData, //省数据
            data_city: {}, //市数据
            data_area: {}, //县数据
            formLabel: {
                name: '',
                mobile: '',
                job: '',
                qq: '',
                email: '',
                address: '',
                province: '', //省份id
                city: '', //城市id
                area: '', //区域id
            },
            rules: {
                name: [{ required: true, message: '姓名不得为空', trigger: 'blur' }],
                mobile: [{ required: true, message: '联系电话不得为空', trigger: 'blur' }],
                job: [{ required: false, message: '工作职位不得为空', trigger: 'blur' }],
                qq: [{ required: false, message: 'qq不得为空', trigger: 'blur' }],
                email: [{ required: false, message: '邮箱不得为空', trigger: 'blur' }],
                province: [{ required: true, message: '请选择省/市/自治区/行政区', trigger: 'change' }],
                city: [{ required: true, message: '请选择市/区', trigger: 'change' }],
                area: [{ required: true, message: '请选择县/区', trigger: 'change' }],
                address: [{ required: true, message: '请填写详细地址', trigger: 'blur' }],
            },
        };
    },
    mounted() {
        const { status, id } = this.$route.query;
        if (status && id) {
            this.findAgent(id);
        }
    },
    methods: {
        findAgent(id) {
            this.id = id;
            postRequest('/agent/find', { id })
                .then(result => {
                    const { code, data } = result.data;
                    if (code === 200) {
                        this.formLabel = data;
                        const { province, city, area } = data;
                        this.province = province;
                        this.city = city;
                        this.area = area;
                    }
                })
                .catch(error => {
                    this.$message({ type: 'error', message: '服务器错误!' });
                    this.$router.go(-1);
                });
        },
        //选择省
        changeProvince() {
            const province_length = this.province.length - 6;
            const province_addr = this.province.substring(province_length);
            const province_area = this.province.substring(0, province_length);
            const { label, children } = this.data[province_area];
            this.formLabel.province = label;
            this.data_city = children;
            this.city = '';
            this.area = '';
        },

        //选择市
        changeCity() {
            const city_length = this.city.length - 6;
            const city_addr = this.city.substring(city_length);
            const city_area = this.city.substring(0, city_length);
            const { label, children } = this.data_city[city_area];
            this.formLabel.city = label;
            this.data_area = children;
            this.area = '';
        },

        //选择县
        changeArea() {
            const area_length = this.area.length - 6;
            const area_addr = this.area.substring(area_length);
            const area_area = this.area.substring(0, area_length);
            this.formLabel.area = this.data_area[area_area].label;
        },

        submitForm() {
            this.$refs['formLabel'].validate(valid => {
                if (valid) {
                    this.submitForms();
                } else {
                    return false;
                }
            });
        },

        submitForms() {
            let url = '',
                failedMessage = '',
                succMessage = '';
            const { name, job, qq, mobile, email, province, city, area, address } = this.formLabel;
            if (this.id) {
                url = '/agent/update';
                succMessage = '更新成功';
                failedMessage = '更新失败';
            } else {
                url = '/agent/add';
                succMessage = '添加成功';
                failedMessage = '添加失败';
            }
            postRequest(url, { id: this.id, ...this.formLabel })
                .then(result => {
                    const { code, message } = result.data;
                    if (code === 200) {
                        this.$message({ type: 'success', message: succMessage });
                        this.resetForm('formLabel');
                    }
                })
                .catch(error => {
                    this.$message({ type: 'error', message: failedMessage });
                });
        },

        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.province = '';
            this.city = '';
            this.area = '';
        },
    },
};
</script>
<style lang="" scope></style>



// WEBPACK FOOTER //
// src/pages/agent/AddAgent.vue